import { toIframe } from './util';

/**
 * @param {HTMLDivElement} playerWrapper
 * @param {HTMLImageElement} posterImage
 * @param {HTMLIFrameElement} iframe
 * @param {boolean=} autoplay
 */
const initPlayback = (playerWrapper, posterImage, iframe, autoplay = true) => {
    playerWrapper.className += ' mscr-yt__wrapper--loaded';
    (/** @type {HTMLDivElement} */(playerWrapper.firstElementChild)).style.display = 'none';
    if (!autoplay) {
        iframe.setAttribute('data-src', iframe.getAttribute('data-src').replace('autoplay=1', 'autoplay=0'));
    }
    iframe = toIframe(iframe);
    iframe.width = posterImage.width.toString();
    iframe.height = posterImage.height.toString();
    iframe.style.display = 'block';
};

/**
 * @param {HTMLDivElement} playerWrapper
 * @param {boolean=} twoClick
 */
export const initPlayer = (playerWrapper, twoClick = false) => {
    const button = playerWrapper.querySelector('button');
    const img = playerWrapper.querySelector('.js-mscr-yt__optin__bg');
    const frame = playerWrapper.querySelector('.js-yt-iframe');

    if (twoClick) {
        button.addEventListener('click', () => initPlayback(playerWrapper, img, frame));
    } else {
        initPlayback(playerWrapper, img, frame, false);
    }
};

/**
 * @param {boolean} twoClick
 */
export const init = (twoClick = true) => {
    const playerWrappers = document.querySelectorAll('.js-mscr-yt__wrapper');
    for (let i = 0; i < playerWrappers.length; i++) {
        initPlayer(playerWrappers[i], twoClick);
    }
};
